import { render, staticRenderFns } from "./PoChekam.vue?vue&type=template&id=74a4f4ee&scoped=true&"
import script from "./PoChekam.vue?vue&type=script&lang=js&"
export * from "./PoChekam.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74a4f4ee",
  null
  
)

export default component.exports